var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01522 15.75C7.54405 16.2168 8.23878 16.5 8.99958 16.5C9.76045 16.5 10.4551 16.2168 10.9839 15.75M13.4996 6C13.4996 4.80652 13.0255 3.66193 12.1816 2.81802C11.3376 1.97411 10.1931 1.5 8.99958 1.5C7.8061 1.5 6.66153 1.97411 5.81761 2.81802C4.9737 3.66193 4.49959 4.80652 4.49959 6C4.49959 8.31765 3.91494 9.9045 3.26184 10.9541C2.71094 11.8394 2.43549 12.2821 2.44558 12.4056C2.45677 12.5423 2.48574 12.5944 2.59592 12.6762C2.69544 12.75 3.14403 12.75 4.04123 12.75H13.958C14.8551 12.75 15.3038 12.75 15.4032 12.6762C15.5135 12.5944 15.5424 12.5423 15.5536 12.4056C15.5637 12.2821 15.2883 11.8394 14.7374 10.9541C14.0842 9.9045 13.4996 8.31765 13.4996 6Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationprofile);
export default __webpack_public_path__ + "static/media/notificationprofile.794f52a18e35cfd471bdbf342b6d9e21.svg";
export { ForwardRef as ReactComponent };